import { VideoDataParamsTypes, VideoDataResTypes } from './types';

import axiosInstance from 'services/common/instance';

export const getVideoDataService = async (
  params?: VideoDataParamsTypes,
): Promise<VideoDataResTypes> => {
  const res = await axiosInstance.get('news-videos', { params });
  return res.data;
};

export const placeholder = '';
